var exports = {
  "kL": "CosmeticSettings.module__container___YTZPMT",
  "wx": "CosmeticSettings.module__header___YTZPMT",
  "DD": "CosmeticSettings.module__title___YTZPMT",
  "h_": "CosmeticSettings.module__description___YTZPMT",
  "Vg": "CosmeticSettings.module__grid___YTZPMT",
  "nK": "CosmeticSettings.module__plateGrid___YTZPMT" + " " + "CosmeticSettings.module__grid___YTZPMT",
  "Vs": "CosmeticSettings.module__tile___YTZPMT",
  "Q9": "CosmeticSettings.module__tileSelected___YTZPMT",
  "Pf": "CosmeticSettings.module__label___YTZPMT",
  "YS": "CosmeticSettings.module__avatarSample___YTZPMT",
  "vX": "CosmeticSettings.module__avatarWithFrame___YTZPMT",
  "Lz": "CosmeticSettings.module__plateSample___YTZPMT",
  "oh": "CosmeticSettings.module__plateName___YTZPMT",
};

module.exports = exports;
